module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_plan_show_bg_05-1e1ed5403f403a9a5a2b475a99b916e8.png";